import React from 'react';
import CurrencyFormat from '../../Formatters/CurrencyFormat';

export default function DigitalCoverageAmounts(isAmerico) {
  const start = isAmerico ? 25000 : 100000;
  const end = isAmerico ? 1000000 : 3000000;
  const increment = isAmerico ? 25000 : 50000;
  var amounts = [];

  for (var i = start; i <= end; i += increment) {
    if (i === start) {
      amounts.push({ label: <CurrencyFormat number={i} whole shortK />, value: i });
    } else if (i === end) {
      if (end < 1000000) {
        amounts.push({ label: <CurrencyFormat number={i} whole shortK />, value: i });
      } else {
        amounts.push({ label: <CurrencyFormat number={i} whole shortM />, value: i });
      }
    } else {
      amounts.push({ label: '', value: i });
    }
  }

  return amounts;
}
